// extracted by mini-css-extract-plugin
export var typingIndicator = "_l3-0";